import React from 'react';
import { Container, Col, Row } from 'react-grid-system';
import PropTypes from 'prop-types';

import { getObjectProperty } from '../../utils';
import Image from '../Image';
import Video from '../Video';
import Alert from '../Alert';
import Cards from '../Cards';
import Button from '../Button';

import styles from './sectionContained.module.scss';

function handleAlert(component) {
  return (
    <div className={styles.wrapper} key={component.id}>
      <Alert
        {...component}
      />
    </div>
  );
}

function handleCards(component) {
  return (
    <Cards
      {...component}
      key={component.id}
    />
  );
}

function handleImage(component) {
  return (
    <Image
      {...component}
      key={component.id}
    />
  );
}

function handleTextBlock(component) {
  return (
    <div
      key={component.id}
      dangerouslySetInnerHTML={{
        __html: component.content.childMarkdownRemark.html,
      }}
    />
  );
}

function handleVideo(component) {
  return (
    <div className={styles.wrapper} key={component.id}>
      {component.title && (<h2>{component.title}</h2>)}
      <Video
        aspectRatio={component.aspectRatio}
        videoSrc={component.videoUrl}
      />
    </div>
  );
}

function SectionContained(props) {
  const {
    components,
    sectionButton,
  } = props;

  const sections = {
    ContentfulAlert: handleAlert,
    ContentfulCards: handleCards,
    ContentfulImage: handleImage,
    ContentfulTextBlock: handleTextBlock,
    ContentfulVideo: handleVideo,
  };

  return (
    <div className={styles.section}>
      <Container>
        <Row>
          {components && components.map((component) => {
            const sectionHandler = getObjectProperty(sections, component.__typename, null);

            return (
              <Col xs={12} md={8} push={{ md: 2 }} key={component.id}>
                {sectionHandler(component)}
              </Col>
            );
          })}
        </Row>

        {sectionButton && (
          <Row>
            <Col>
              <div className={styles.btnContainer}>
                {sectionButton.map(cta => (
                  <Button
                    {...cta}
                    key={cta.id}
                    link={cta.url}
                    size="large"
                    isMobileFull
                    modifierclass={styles.btn}
                  >
                    {cta.label}
                  </Button>
                ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default SectionContained;

SectionContained.propTypes = {
  components: PropTypes.arrayOf(PropTypes.object),
  sectionButton: PropTypes.arrayOf(PropTypes.object),
};

SectionContained.defaultProps = {
  components: null,
  sectionButton: null,
};
